import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CustomerModel, OrderCreateModel } from '../../../../../shared/service-proxies/event-service-proxy';

@Component({
    selector: 'app-customer-info-order-card',
    templateUrl: './customer-info-order-card.component.html',
    styleUrl: './customer-info-order-card.component.scss',
    standalone: false
})
export class CustomerInfoOrderCardComponent {
  @Input() order: OrderCreateModel = new OrderCreateModel()
  @Output() nextStep = new EventEmitter<void>();
  @Input() decorativeLineVisible: boolean = false;
  @Input() decorativeCircleVisible: boolean = false;

  @Output() decorativeLineVisibleChange = new EventEmitter<boolean>();
  @Output() dataCleared = new EventEmitter<boolean>(false);

  stepCompleted: boolean = false;

  ngOnChanges(): void {
    if (!this.decorativeCircleVisible) {
      this.isFormValid() == false;
      this.stepCompleted = false;
    }
  }

  showDecorativeLine() {
    this.decorativeLineVisible = true;
    this.decorativeLineVisibleChange.emit(this.decorativeLineVisible);
  }

  isAnyFieldFilled(): boolean {
    return !!this.order.firstname?.trim() || !!this.order.lastname?.trim() || !!this.order.phone?.trim() || !!this.order.email?.trim();
  }
  
  isFormValid(): boolean {
    return !!this.order.firstname && !!this.order.lastname && !!this.order.phone && !!this.order.email;
  }

  clearAll() {
    Object.assign(this.order, { firstname: '', lastname: '', phone: '', email: '' });
    this.order.customerId = '';
    this.dataCleared.emit();
  } 

  openNextStep() {
    this.showDecorativeLine();
    this.stepCompleted = true;
    this.nextStep.emit();
  }
}
